<template>
    <div id="last">
        <a v-if="disabled" class="disabled item">
            <i class="angle double right icon"></i>
        </a>
        <a v-else-if="current_page != total_pages && total_pages > 0" class="item" @click="$parent.change_page(total_pages)">
            <i class="angle double right icon"></i>
        </a>
        <a v-else class="disabled item">
            <i class="angle double right icon"></i>
        </a>
    </div>
</template>

<script>
export default {
    name: "PaginationLast",
    props: {
        current_page: Number,
        total_pages: Number,
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    computed: {
    },
    methods: {
    },
    components: {
    }
}
</script>

<style scoped>
</style>
